/**
 * Column in site map with links of months that clicks out
 * to page with articles for that year & month.
 * This is used for both articles & advice site map as well as buying guides.
 */

import React from 'react'
import styled from '@emotion/styled'
import { string, object } from 'prop-types'
import { Link } from 'gatsby'

const MonthListingContainer = styled.div`
	text-align: center;
`
const Month = styled.div`
	color: ${({ theme }) => theme.colors.gray[400]};
	font-size: 1.2rem;
	font-weight: 700;
	padding: 1.2rem 0;
`
const MonthLink = styled(Link)`
	color: ${({ theme }) => theme.colors.primary};
	display: block;
	font-size: 1.2rem;
	font-weight: 700;
	margin: 0 auto;
	padding: 1.2rem 0;
	width: fit-content;

	&:hover {
		color: ${({ theme }) => theme.colors.tertiary};
	}
`
const Year = styled.p`
	color: ${({ theme }) => theme.colors.gray[600]};
	${({ theme }) => theme.fonts.primary};
	font-size: 1.875rem;
`

export function SiteMapMonthListing({ months, year }) {
	const monthKeys = Object.keys(months)
	return (
		<MonthListingContainer>
			<Year>{year}</Year>
			{monthKeys.map((month) =>
				months[month] ? (
					<MonthLink href={`${months[month]}/`} key={`${year}/${month}`}>
						{month}
					</MonthLink>
				) : (
					<Month key={`${year}/${month}`}>{month}</Month>
				)
			)}
		</MonthListingContainer>
	)
}

SiteMapMonthListing.propTypes = {
	year: string,
	months: object,
}
